export const MFASessionStorageEncryptedOktaUserIdKey = 'token'
export const MFASessionStorageOktaUserNameKey = 'OktaUsername'
export const PersonalizedCookieStateCodeProperty = 'StateCode'
export const UserLoginEmailSessionTokenKey = 'LoginUser'

export const PASSWORD_CHANGE={
    SUCCESS:{
        NAME: 'PasswordChangeSuccess',
        MESSAGE: 'Password Changed Succesfully'
    }, 
    FAILURE:{
        NAME: 'PasswordChangeFailure',
        MESSAGE: 'Error Changing Password'
    }
}

export const PROFILE_EDITED={
    SUCCESS:{
        NAME: 'EditProfileChangeSuccess',
        MESSAGE: 'Profile Edited Succesfully'
    }, 
    FAILURE:{
        NAME: 'EditProfileChangeFailure',
        MESSAGE: 'Error Editing Profile'
    }
}

export const FORGOT_PASSWORD={
    SUCCESS:{
        NAME: 'ForgotPasswordSuccess',
        MESSAGE: 'Forgot password link requested succesfully'
    }, 
    FAILURE:{
        NAME: 'ForgotPasswordFailure',
        MESSAGE: 'Error on Forgot password'
    }
}

export const LOGIN={
    SUCCESS:{
        NAME: 'LoginSuccess',
        MESSAGE: 'Login Succesfully'
    }, 
    FAILURE:{
        NAME: 'LoginFailure',
        MESSAGE: 'Error Login In'
    }
}

export const LOGIN_PKCE={
    SUCCESS:{
        NAME: 'LoginPKCESuccess',
        MESSAGE: 'Login Succesfully using PKCE code flow'
    }, 
    FAILURE:{
        NAME: 'LoginPKCEFailure',
        MESSAGE: 'Error Login In using PKCE code flow'
    }
}

export const REGISTER={
    SUCCESS:{
        NAME: 'RegisterSuccess',
        MESSAGE: 'User Registered Succesfully'
    }, 
    FAILURE:{
        NAME: 'RegisterFailure',
        MESSAGE: 'Error on Registration'
    }
}

export const FF_LOGIN_AUTH_JWT_TOKEN_ENABLED = 'es.web-app-web.login-options.spa-auth-tokens.enabled'
export const FF_MFA_SHOW_MESSAGE_ENABLED = 'es.web-app-web.login-options.multi-factor-customer.enabled'
export const PERSONALIZED_COOKIE_NAME = '.PERSONALIZATION'
export const MFA_REMEMBER_ME_KEY  = 'mfaRememberMe'
export const MFA_ASK_ME_LATER_KEY  = 'askMeAgainHideTime'

export const MFA_ENROLL_STATUS = {
    ACTIVE: 'ACTIVE',
    PENDING_ACTIVATION: 'PENDING_ACTIVATION',
    NO_SETUP: 'NO_SETUP'
}
export const MFA_STATUS = {
    MFA_ENROLL: 'MFA_ENROLL',
    MFA_REQUIRED: 'MFA_REQUIRED'
}
export const MFA_OKTA_LIMIT_REQUEST = 30000

export const MFA_GET_STARTED={
    GET_STARTED:{
        NAME: 'MfaGetStarted',
        MESSAGE: 'Get started'
    }, 
    ASK_ME_AGAIN_LATER:{
        NAME: 'MfaAskMeAgainLater',
        MESSAGE: 'Ask me again later'
    }
}

export const MFA_SETUP_VERIFICATION={
    SMS_SETUP:{
        NAME : 'MfaSmsSetupVerification',
        MESSAGE: 'Sms setup verification'
    }, 
    EMAIL_SETUP:{
        NAME: 'MfaEmailSetupVerification',
        MESSAGE: 'Email setup verification'
    }, 
    CLOSE:{
        NAME: 'MfaSetupVerficationClose',
        MESSAGE: 'Setup verification close'
    }
}

export const MFA_SETUP_SMS={
    SEND_CODE:{
        NAME : 'MfaSetupSmsSendCode',
        MESSAGE: 'Setup SMS send code'
    }, 
    SEND_CODE_FAILURE:{
        NAME : 'MfaSetupSmsSendCodeFailure',
        MESSAGE: 'Setup SMS send code failure'
    }, 
    GO_BACK:{
        NAME: 'MfaSetupSmsGoBack',
        MESSAGE: 'Setup SMS go back'
    },
    GO_BACK_FAILURE:{
        NAME: 'MfaSetupSmsGoBackFailure',
        MESSAGE: 'Setup SMS go back failure'
    },
    CLOSE:{
        NAME: 'MfaSetupSmsClose',
        MESSAGE: 'Setup SMS close'
    }
}

export const MFA_SETUP_EMAIL={
    SEND_CODE:{
        NAME : 'MfaSetupEmailSendCode',
        MESSAGE: 'Setup email send code'
    }, 
    SEND_CODE_FAILURE:{
        NAME : 'MfaSetupEmailSendCodeFailure',
        MESSAGE: 'Setup email send code failure'
    }, 
    GO_BACK:{
        NAME: 'MfaSetupEmailGoBack',
        MESSAGE: 'Setup email go back'
    },
    GO_BACK_FAILURE:{
        NAME: 'MfaSetupEmailGoBackFailure',
        MESSAGE: 'Setup email go back failure'
    },
    CLOSE:{
        NAME: 'MfaSetupEmailClose',
        MESSAGE: 'Setup email close'
    }
}

export const MFA_VERIFY={ 
    GO_BACK:{
        NAME: 'MfaVerifyFactorGoBack',
        MESSAGE: 'Verify factor go back'
    },
    CLOSE:{
        NAME: 'MfaVerifyFactorClose',
        MESSAGE: 'Verify factor close'
    }
}

export const MFA_SMS_VERIFY={
    VERIFY_CODE:{
        NAME : 'MfaVerifySmsSendCode',
        MESSAGE: 'Verify SMS send code'
    }, 
    RESEND_SMS:{
        NAME: 'MfaVerifySmsResend',
        MESSAGE: 'Verify SMS resend code'
    }
}

export const MFA_EMAIL_VERIFY={
    VERIFY_CODE:{
        NAME : 'MfaVerifyEmailSendCode',
        MESSAGE: 'Verify email send code'
    }, 
    RESEND_EMAIL:{
        NAME: 'MfaVerifyEmailResend',
        MESSAGE: 'Verify email resend code'
    }
}

export const MFA_EMROLLMENT={
    DONE:{
        NAME : 'MfaEnrollmentSuccess',
        MESSAGE: 'Enrollment success'
    },
    FAILURE:{
        NAME : 'MfaEnrollmentFailure',
        MESSAGE: 'Enrollment failure'
    }
}

export const MFA_LOGIN_SEND_CODE={
    SEND_CODE_SMS:{
        NAME : 'MfaSendLoginCodeViaSMS',
        MESSAGE: 'Send login code via SMS'
    }, 
    SEND_CODE_SMS_FAILURE:{
        NAME : 'MfaSendLoginCodeViaSMSFailure',
        MESSAGE: 'Send login code via SMS failure'
    }, 
    SEND_CODE_EMAIL:{
        NAME : 'MfaSendLoginCodeViaEmail',
        MESSAGE: 'Send login code via email'
    },
    SEND_CODE_EMAIL_FAILURE:{
        NAME : 'MfaSendLoginCodeViaEmailFailure',
        MESSAGE: 'Send login code via email failure'
    },
    CLOSE:{
        NAME: 'MfaSendLoginCodeClose',
        MESSAGE: 'Send login code close'
    }
}

export const MFA_LOGIN_VERIFY={
    GO_BACK:{
        NAME : 'MfaLoginVerifyGoBack',
        MESSAGE: 'Login verify go back'
    }, 
    CLOSE:{
        NAME: 'MfaLoginVerifyClose',
        MESSAGE: 'Login verify close'
    }
}

export const MFA_LOGIN_VERIFY_SMS={
    SEND_CODE_SMS:{
        NAME : 'MfaLoginVerifySmsVerify',
        MESSAGE: 'Send login code via SMS'
    }, 
    RESEND_SMS:{
        NAME: 'MfaLoginVerifySmsResend',
        MESSAGE: 'Login verify SMS resend'
    }
}

export const MFA_LOGIN_VERIFY_EMAIL={
    SEND_CODE_EMAIL:{
        NAME : 'MfaLoginVerifyEmailVerify',
        MESSAGE: 'Send login code via email'
    }, 
    RESEND_EMAIL:{
        NAME: 'MfaLoginVerifyEmailResend',
        MESSAGE: 'Login verify email resend'
    }
}

export const MFA_RESET_FACTOR={
    RESET_SUCCESS:{
        NAME : 'MfaResetFactorSuccess',
        MESSAGE: 'Mfa reset factor success'
    }, 
    RESET_FAILURE:{
        NAME : 'MfaResetFactorFailure',
        MESSAGE: 'Mfa reset factor failure'
    }
}

export const MFA_REMEMBER_ME={
    CHECKED:{
        NAME: 'MfaRememberMeChecked',
        MESSAGE: 'Remember me was checked'
    }
}

export const PROFILE_UPDATE_MFA={
    REMOVE:{
        NAME : 'MfaProfileMfaFactorRemove',
        MESSAGE: 'Profile MFA Factor remove'
    },
    REMOVE_FAILURE:{
        NAME : 'MfaProfileMfaFactorFailure',
        MESSAGE: 'Profile MFA Factor remove failure'
    },
    ADD:{
        NAME: 'MfaProfileMfaFactorAdd',
        MESSAGE: 'Profile MFA Factor add'
    }, 
    ADD_FAILURE:{
        NAME: 'MfaProfileMfaFactorAddFailure',
        MESSAGE: 'Profile MFA Factor add failure'
    }, 
    EDIT:{
        NAME: 'MfaProfileSmsFactorEdit',
        MESSAGE: 'Profile MFA Sms Factor phone number edit'
    }, 
    EDIT_FAILURE:{
        NAME: 'MfaProfileSmsFactorEditFailure',
        MESSAGE: 'Profile MFA Sms Factor phone number edit failure'
    },
    TURN_OFF:{
        NAME: 'MfaProfileMfaTurnOff',
        MESSAGE: 'Profile MFA turn off'
    }, 
    TURN_OFF_FAILURE:{
        NAME: 'MfaProfileMfaTurnOffFailure',
        MESSAGE: 'Profile MFA turn off failure'
    },
    SET_UP:{
        NAME: 'MfaProfileMfaSetUp',
        MESSAGE: 'Profile MFA SetUp'
    }
}